<div class="layout-col full">
  <elder-table
    class="flex"
    matSort
    [data]="sortProperties$ | async"
    [selectionVisible]="true"
    [selectionMultiEnabled]="true"
  >
    <elder-data-toolbar
      *elderTableToolbar
      [canAdd]="true"
      [canRemove]="true"
      [canMore]="false"
      (requestNew)="addProperty()"
      (requestRemove)="onRemove($event)"
    >
    </elder-data-toolbar>

    <!-- property Column -->
    <ng-container matColumnDef="property">
      <th mat-header-cell *matHeaderCellDef>{{ 'properties.property' | translate }}</th>
      <td mat-cell *matCellDef="let prop">
        <mat-form-field elderDense>
          <elder-select
            appPropertySelect
            name="property"
            productKind
            required
            [placeholder]="null"
            valueAsId
            [(ngModel)]="prop.propertyId"
            (entityChange)="onPropertyChange(prop, $event)"
          >
            <div *elderSelectValue="let prop" class="layout-col">
              <span class="text-body-medium">{{ prop.description }}</span>
              <span class="text-body-small">{{ prop.id }}</span>
            </div>

            <app-property-browser *elderSelectionModelPopup class="flex" productKind>
            </app-property-browser>
          </elder-select>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- sort order Column -->
    <ng-container matColumnDef="sortOrder">
      <th mat-header-cell *matHeaderCellDef>{{ 'SortOrder.title' | translate }}</th>
      <td mat-cell *matCellDef="let prop">
        <mat-form-field elderDense>
          <elder-select
            appSortOrderSelect
            name="property"
            required
            [placeholder]="null"
            valueAsId
            [(ngModel)]="prop.sortOrder"
          >
          </elder-select>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- tolerance order Column -->
    <ng-container matColumnDef="tolerance">
      <th mat-header-cell *matHeaderCellDef>{{ 'context.tolerance' | translate }}</th>
      <td mat-cell *matCellDef="let prop">
        @if (prop?.property?.type === PropertyType.QUANTITY) {
          <div class="layout-row">
            <mat-form-field elderDense class="layout-row">
              <elder-quantity-input
                name="tolerance"
                [required]="false"
                [(ngModel)]="prop.tolerance"
              >
              </elder-quantity-input>
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
          </div>
        }
      </td>
    </ng-container>

    <!-- order controls -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
      <td mat-cell *matCellDef="let prop">
        <div class="place-start-center">
          <button mat-icon-button (click)="moveUp(prop)" elderStopEventPropagation>
            <mat-icon>arrow_drop_up</mat-icon>
          </button>
          <button mat-icon-button (click)="moveDown(prop)" elderStopEventPropagation>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>
  </elder-table>
</div>
